import React from 'react'
import classNames from 'classnames'
import dayjs from 'dayjs'

import './styles.scss'

const Cell = ({ title = null, content = '', highlight = false }) => {
  return (
    <div className="tab-delivery-details__value-wrapper">
      {title && <span>{title}</span>}
      <div
        className={classNames('tab-delivery-details__value', {
          'tab-delivery-details__value--highlight': highlight,
        })}
      >
        {content}
      </div>
    </div>
  )
}

const DESTINATION = {
  STATSOCIAL: 'StatSocial',
  CINT: 'CINT',
  CRITEO: 'Criteo',
}

const DeliveryDetails = ({ data }) => {
  const lastDelivery = data.deliveries.at(-1)

  const DESTINATIONS_MAP = {
    [DESTINATION.STATSOCIAL]: (
      <>
        <div className="tab-delivery-details__item-wrapper">
          <p className="tab-delivery-details__label">Delivery Size</p>
          <Cell title={'Target'} content={lastDelivery.deliverySize.target} />
          <Cell title={'Insight'} content={lastDelivery.deliverySize.insight} />
        </div>
        <div className="tab-delivery-details__item-wrapper">
          <p className="tab-delivery-details__label">Delivery Path</p>
          <Cell title={'Target'} content={lastDelivery.deliveryPath.target} />
          <Cell title={'Insight'} content={lastDelivery.deliveryPath.insight} />
        </div>
      </>
    ),
    [DESTINATION.CINT]: (
      <>
        <div className="tab-delivery-details__item-wrapper">
          <p className="tab-delivery-details__label">lotame_id Size</p>
          <Cell content={lastDelivery.deliverySize.lotame} />
        </div>
        <div className="tab-delivery-details__item-wrapper">
          <p className="tab-delivery-details__label">Delivery Location</p>
          <Cell content={lastDelivery.deliveryPath.lotame} />
        </div>
      </>
    ),
    [DESTINATION.CRITEO]: (
      <>
        <div className="tab-delivery-details__item-wrapper">
          <p className="tab-delivery-details__label">Delivery Size</p>
          <Cell title={'ios_id'} content={lastDelivery.deliverySize.ios} />
          <Cell title={'android_id'} content={lastDelivery.deliverySize.android} />
        </div>
        <div className="tab-delivery-details__item-wrapper">
          <p className="tab-delivery-details__label">Delivery Path</p>
          <Cell title={'ios'} content={lastDelivery.deliveryPath.ios} />
          <Cell title={'android'} content={lastDelivery.deliveryPath.android} />
        </div>
      </>
    ),
  }

  return (
    <div className="tab-delivery-details">
      <div className="tab-delivery-details__header">
        <h3 className="tab-delivery-details__header-title">Delivery Details</h3>
      </div>
      <div className="tab-delivery-details__content">
        <div>
          <If condition={lastDelivery.sizeCheck === 'Fail'}>
            <div className="tab-delivery-details__size-check">⚠️ Size check failed</div>
          </If>
          <div className="tab-delivery-details__item-wrapper">
            <p className="tab-delivery-details__label">Destination</p>
            <Cell content={data.deliveryDestination} highlight />
          </div>
          <div className="tab-delivery-details__item-wrapper">
            <p className="tab-delivery-details__label">Delivery Date</p>
            <Cell content={dayjs(lastDelivery.deliveryDate).format('YYYY-MM-DD')} highlight />
          </div>
          {/* <div className="tab-delivery-details__item-wrapper">
            <p className="tab-delivery-details__label">Delivery Cadence</p>
            <Cell content={data.deliveryCadence} />
          </div> */}
          {DESTINATIONS_MAP[data.deliveryDestination]}
        </div>
      </div>
    </div>
  )
}

export default DeliveryDetails
